(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["runnur-doelplanner"] && !Shopify.designMode) return;
  try {
    
(function(){
/** Pure, local calculations. No prediction model, storage or network access. */
const BAND_RULES = Object.freeze({
  minDistance: 0.1, maxDistance: 100,
  minPace: 120, maxPace: 1800,
  minWeeks: 4, maxAssessmentWeeks: 52,
  ambitiousGapPercent: 5, veryAmbitiousGapPercent: 12,
  shortHorizonWeeks: 12, lowAvailabilityDays: 2,
  sameDistanceToleranceKm: 0.05,
});
const present = value => value !== '' && value !== null && value !== undefined;
const number = value => present(value) ? Number(String(value).replace(',', '.')) : NaN;
const DAY = 86400000;
const timeMessage = 'Deze tijd lijkt niet te kloppen. Controleer uren, minuten en seconden.';
function duration(data, prefix) {
  const fields = ['Hours', 'Minutes', 'Seconds'].map(part => data[prefix + part]);
  if (!fields.some(present)) return null;
  const [h, m, s] = fields.map(value => present(value) ? number(value) : 0);
  if (![h, m, s].every(Number.isInteger) || h < 0 || h > 99 || m < 0 || m > 59 || s < 0 || s > 59) return null;
  const seconds = h * 3600 + m * 60 + s;
  return seconds > 0 ? seconds : null;
}
function dateStamp(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const [y, m, d] = value.split('-').map(Number);
  const stamp = Date.UTC(y, m - 1, d);
  return new Date(stamp).toISOString().slice(0, 10) === value ? stamp : null;
}
function todayStamp(now) {
  if (typeof now === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(now)) return dateStamp(now);
  const date = now instanceof Date ? now : new Date(now);
  if (Number.isNaN(date.getTime())) return null;
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
}
function checkDistance(value, field, errors, rules, goal = false) {
  const n = number(value);
  if (!Number.isFinite(n) || n < rules.minDistance || n > rules.maxDistance) errors[field] = goal && !present(value)
    ? 'Kies een streefafstand.' : `Vul een geldige afstand in. Deze planner werkt van ${String(rules.minDistance).replace('.', ',')} tot ${rules.maxDistance} kilometer.`;
  return n;
}
function checkTime(data, prefix, distance, errors, rules) {
  const seconds = duration(data, prefix);
  if (seconds === null) errors[prefix + 'Hours'] = timeMessage;
  else if (Number.isFinite(distance) && distance > 0 && (seconds / distance < rules.minPace || seconds / distance > rules.maxPace)) errors[prefix + 'Hours'] = 'Controleer je afstand en tijd. Deze combinatie valt buiten het bereik van deze planner (2 tot 30 minuten per kilometer).';
}
function validateStep(step, data = {}, now = new Date(), rules = BAND_RULES) {
  const errors = {};
  if (step === 1 && data.noRecent !== true) {
    const distance = checkDistance(data.recentDistance, 'recentDistance', errors, rules);
    checkTime(data, 'recent', distance, errors, rules);
    if (!['training', 'race'].includes(data.recentType)) errors.recentType = 'Kies training of wedstrijd.';
  }
  if (step === 2) {
    const distance = checkDistance(data.goalDistance, 'goalDistance', errors, rules, true);
    if (data.noGoalTime !== true) checkTime(data, 'goal', distance, errors, rules);
    const target = dateStamp(data.goalDate), today = todayStamp(now);
    if (target === null || today === null || target <= today) errors.goalDate = 'Je streefdatum moet in de toekomst liggen.';
    else if ((target - today) / DAY > 3653) errors.goalDate = 'Kies een datum binnen tien jaar. Verder vooruit geeft deze planner geen bruikbare richting.';
  }
  if (step === 3) {
    if (![2, 3, 4, 5].includes(number(data.days))) errors.days = 'Kies hoeveel dagen je echt kunt trainen.';
    if (!['beginner', 'under1', '1to3', 'over3'].includes(data.experience)) errors.experience = 'Kies hoeveel hardloopervaring je hebt.';
  }
  return errors;
}
function calculate(data, now = new Date(), rules = BAND_RULES) {
  const errors = Object.assign({}, ...[1, 2, 3].map(step => validateStep(step, data, now, rules)));
  if (Object.keys(errors).length) {
    const error = new Error('We konden je berekening niet afronden. Controleer je antwoorden; ze blijven staan.');
    error.fields = errors;
    throw error;
  }
  const recentDistance = data.noRecent === true ? null : number(data.recentDistance);
  const recentTime = data.noRecent === true ? null : duration(data, 'recent');
  const goalDistance = number(data.goalDistance);
  const goalTime = data.noGoalTime === true ? null : duration(data, 'goal');
  const currentPace = recentTime === null ? null : recentTime / recentDistance;
  const currentSpeed = recentTime === null ? null : recentDistance / (recentTime / 3600);
  const goalPace = goalTime === null ? null : goalTime / goalDistance;
  const samePaceFinish = currentPace === null ? null : currentPace * goalDistance;
  const gapPercent = currentPace === null || goalPace === null ? null : (currentPace - goalPace) / currentPace * 100;
  const daysRemaining = Math.round((dateStamp(data.goalDate) - todayStamp(now)) / DAY);
  const weeks = Math.floor(daysRemaining / 7);
  const trainingDays = number(data.days);
  const reasons = [];
  if (currentPace === null) reasons.push('Je hebt nog geen recente looptijd ingevuld.');
  if (goalPace === null) reasons.push('Je hebt nog geen gewenste eindtijd gekozen.');
  if (recentDistance !== null && Math.abs(recentDistance - goalDistance) > rules.sameDistanceToleranceKm) reasons.push('Je recente afstand en je doelafstand verschillen. Hetzelfde tempo doorrekenen is alleen een rekenvoorbeeld, geen voorspelling.');
  if (recentTime !== null && data.recentType === 'training') reasons.push('Een training laat niet automatisch zien hoe snel je een wedstrijd kunt lopen.');
  if (weeks > rules.maxAssessmentWeeks) reasons.push('Je doel ligt meer dan een jaar vooruit. Je niveau kan in die tijd sterk veranderen.');
  if (data.experience === 'beginner') reasons.push('Als beginner heb je eerst meer eigen loopervaring nodig voor een bruikbare vergelijking.');
  let band = 'onvoldoende gegevens';
  let explanation;
  if (reasons.length) explanation = reasons.join(' ');
  else {
    const veryAmbitious = gapPercent > rules.veryAmbitiousGapPercent
      || (gapPercent > rules.ambitiousGapPercent && weeks < rules.shortHorizonWeeks);
    const ambitious = gapPercent > 0 || weeks < rules.minWeeks || trainingDays <= rules.lowAvailabilityDays || data.experience === 'under1';
    band = veryAmbitious ? 'zeer uitdagend' : ambitious ? 'uitdagend' : 'behoudend';
    explanation = `${gapPercent > 0 ? 'Je gewenste tempo is sneller dan je recente wedstrijdtempo.' : 'Je gewenste tempo is gelijk aan of rustiger dan je recente wedstrijdtempo.'} Je hebt ${weeks} volledige ${weeks === 1 ? 'week' : 'weken'} en ${trainingDays === 5 ? '5 of meer' : trainingDays} dagen per week beschikbaar. ${data.experience === 'under1' ? 'Je hebt nog minder dan een jaar ervaring. ' : ''}Dit is een voorzichtige vuistregel, geen voorspelling of garantie.`;
  }
  const firstStep = recentTime === null
    ? 'Noteer bij je volgende gebruikelijke loopmoment de afstand en tijd. Vul die hier daarna in.'
    : goalTime === null
      ? 'Kies eerst of je de afstand wilt uitlopen of ook voor een tijd wilt gaan. Bewaar je recente looptijd als vertrekpunt.'
      : weeks < rules.minWeeks
        ? 'Vergelijk je doel vandaag nog eens met je recente looptijd. Kies zo nodig een rustiger doeltempo of een latere datum.'
        : 'Zet je volgende vertrouwde, rustige loopmoment in je agenda. Bouw vanuit wat je nu al gewend bent.';
  return { recentDistance, recentTime, goalDistance, goalTime, currentPace, currentSpeed, goalPace, samePaceFinish, gapPercent, weeks, daysRemaining, band, explanation, firstStep,
    trainingDays, experience: data.experience, goalDate: data.goalDate,
    disclaimer: 'Dit is een richting op basis van beperkte invoer. Het is geen professioneel trainingsadvies en geen garantie.',
    comparisonLabel: 'Rekenvoorbeeld bij hetzelfde tempo — geen voorspelling',
  };
}
function formatPace(seconds) {
  if (seconds === null || !Number.isFinite(seconds) || seconds < 0) return '—';
  const rounded = Math.round(seconds);
  return `${Math.floor(rounded / 60)}:${String(rounded % 60).padStart(2, '0')}`;
}
function formatTime(seconds) {
  if (seconds === null || !Number.isFinite(seconds) || seconds < 0) return '—';
  const rounded = Math.round(seconds);
  const h = Math.floor(rounded / 3600), m = Math.floor(rounded % 3600 / 60), s = rounded % 60;
  return h ? `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}` : `${m}:${String(s).padStart(2, '0')}`;
}

const EVENTS = Object.freeze(['view','start','step_complete','result_view','email_prompt_view','lead_submit_success','lead_submit_error','primary_cta_click'].map(s=>'doelplanner_'+s));
// No default sink. Connecting a production adapter requires independent consent verification.
function createAnalytics({consent=()=>false,sink=null}={}) {
  return (event, properties={}) => {
    if (!EVENTS.includes(event) || !sink || consent() !== true) return false;
    const safe={};
    if ([1,2,3].includes(properties.step)) safe.step=properties.step;
    if (['unavailable','invalid','duplicate','network'].includes(properties.reason)) safe.reason=properties.reason;
    try { sink(event,safe); return true; } catch { return false; }
  };
}

// Editable public copy. No backend URL or production analytics is configured.
const COPY = Object.freeze({
  title:'Waar loop jij naartoe?',
  intro:'Vul je huidige niveau en hardloopdoel in. Je krijgt direct je doeltempo, een eerste inschatting en één concrete volgende stap.',
  start:'Maak mijn doelplan ↗',
  next:'Verder',
  result:'Bekijk mijn richting',
  emailHeading:'Wil je het uitgebreidere plan?',
  emailSubmit:'Stuur mijn doelplan',
  cta:'Ontdek het verhaal van RUNNUR ↗',
  ctaUrl:'https://runnur.nl/pages/over-ons',
});
const FEATURES = Object.freeze({ emailDelivery:false, analytics:false, nutrition:false });

const GROWTH_VERSION = 2;
const PASS_TTL_DAYS = 365;

const OPTIONS = Object.freeze({
  purpose: ['finish', 'faster', 'rhythm', 'confidence', 'together', ''],
  reason: ['event', 'personal', 'first', 'together', ''],
  freshness: ['month', 'quarter', 'older', 'unknown', ''],
  representative: ['low', 'medium', 'high', ''],
  currentRhythm: ['0', '1', '2', '3', '4plus', ''],
  ambition: ['calm', 'firm', 'explore', ''],
  sessionTime: ['under30', '30to60', 'over60', ''],
  obstacle: ['time', 'planning', 'start', 'alone', 'missed', ''],
  phase: ['orient', 'plan', 'do', 'reflect', ''],
  help: ['planning', 'motivation', 'story', 'community', 'product', 'none', ''],
  reflection: ['worked', 'adjust', 'missed', ''],
});

function validateGrowth(data = {}) {
  const errors = {};
  for (const [key, allowed] of Object.entries(OPTIONS)) {
    if (!allowed.includes(String(data[key] ?? ''))) errors[key] = 'Kies een van de getoonde opties.';
  }
  return errors;
}

function monthEnd(month) {
  if (typeof month !== 'string' || !/^\d{4}-\d{2}$/.test(month)) return null;
  const [year, value] = month.split('-').map(Number);
  if (value < 1 || value > 12) return null;
  return new Date(Date.UTC(year, value, 0)).toISOString().slice(0, 10);
}

function basisCard(data, result) {
  const known = [];
  const unknown = [];
  const assumptions = [];
  known.push(`${result.goalDistance} km als doel`);
  known.push(`${result.daysRemaining} dagen tot je streefdatum`);
  if (result.goalTime === null) unknown.push('gewenste eindtijd');
  else known.push('gewenste eindtijd');
  if (result.recentTime === null) unknown.push('recente looptijd');
  else known.push(`recente ${data.recentType === 'race' ? 'wedstrijd' : 'training'}`);
  if (data.freshness === 'older' || data.freshness === 'unknown') assumptions.push('je huidige niveau kan anders zijn dan deze meting');
  if (data.representative === 'low') assumptions.push('je gaf aan dat de recente tijd geen eerlijk beeld geeft');
  if (result.recentDistance !== null && Math.abs(result.recentDistance - result.goalDistance) > 0.05) assumptions.push('hetzelfde tempo over een andere afstand is alleen een rekenvoorbeeld');
  if (!assumptions.length) assumptions.push('de invoer is een momentopname, geen voorspelling');
  return { known: known.slice(0, 3), unknown: unknown.slice(0, 2), assumptions: assumptions.slice(0, 2) };
}

function improvementPrompt(data, result) {
  if (result.recentTime === null) return 'Noteer bij je volgende gewone loop de afstand en tijd.';
  if (!data.freshness || data.freshness === 'unknown') return 'Geef aan hoe recent je laatste tijd is.';
  if (!data.representative) return 'Geef aan of die tijd een eerlijk beeld van je niveau geeft.';
  if (result.goalTime === null) return 'Kies later een eindtijd als je ook tempo wilt vergelijken.';
  return 'Vul de planner na je volgende meetmoment opnieuw in.';
}

function firstActions(data, result) {
  const actions = [
    { id: 'usual-run', title: 'Plan één vertrouwde loop', text: 'Kies zelf een dag en tijd voor een loop die je al gewend bent.' },
    { id: 'record-time', title: 'Noteer je vertrekpunt', text: result.recentTime === null ? 'Schrijf afstand en tijd op na je volgende gewone loop.' : 'Bewaar deze invoer en vergelijk later alleen met jezelf.' },
    { id: 'review-goal', title: 'Bekijk doel en agenda', text: 'Controleer of de datum en beschikbare dagen echt bij je week passen.' },
  ];
  const preferred = data.obstacle === 'planning' || data.obstacle === 'time' ? 'review-goal'
    : data.obstacle === 'start' ? 'usual-run'
      : data.obstacle === 'missed' ? 'review-goal'
        : result.recentTime === null ? 'record-time' : 'usual-run';
  return { actions, preferred };
}

function contentCards(data) {
  const cards = [];
  if (data.help === 'story' || data.phase === 'orient') cards.push({ title: 'Van keukentafel naar kilometers', text: 'Lees hoe RUNNUR stap voor stap is gebouwd.', url: 'https://runnur.nl/pages/over-ons' });
  if (data.help === 'community' || data.purpose === 'together') cards.push({ title: 'Loop mee met RUNNUR', text: 'Bekijk de actuele verhalen en community-updates.', url: 'https://www.instagram.com/runnurofficial/' });
  if (data.help === 'product') cards.push({ title: 'Bekijk actuele productinformatie', text: 'Bekijk inhoud, voorraad en prijs op de productpagina.', url: 'https://runnur.nl/products/runnur-marathon-bar' });
  return cards.slice(0, 3);
}

const dateOnly = value => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(`${value}T00:00:00Z`));
const timeOnly = value => typeof value === 'string' && /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value);
const icsEscape = value => String(value).replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');

function buildIcs({ title = 'Mijn RUNNUR-moment', date, time, description = '' }, now = new Date()) {
  if (!dateOnly(date) || !timeOnly(time)) throw new Error('Kies eerst een geldige dag en tijd.');
  const start = new Date(`${date}T${time}:00`);
  if (Number.isNaN(start.getTime()) || start <= now) throw new Error('Kies een moment in de toekomst.');
  const end = new Date(start.getTime() + 45 * 60000);
  const stamp = value => value.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  const uid = `runnur-${stamp(start)}@runnur.nl`;
  return ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//RUNNUR//Doelplanner//NL', 'CALSCALE:GREGORIAN', 'BEGIN:VEVENT', `UID:${uid}`, `DTSTAMP:${stamp(now)}`, `DTSTART:${stamp(start)}`, `DTEND:${stamp(end)}`, `SUMMARY:${icsEscape(title)}`, `DESCRIPTION:${icsEscape(description)}`, 'END:VEVENT', 'END:VCALENDAR', ''].join('\r\n');
}

function createPass(data, result, selectedAction = '', now = new Date()) {
  const created = new Date(now);
  const expires = new Date(created.getTime() + PASS_TTL_DAYS * 86400000);
  return {
    version: GROWTH_VERSION,
    createdAt: created.toISOString(),
    expiresAt: expires.toISOString(),
    recentDistance: result.recentDistance,
    recentTime: result.recentTime,
    goalDistance: result.goalDistance,
    goalTime: result.goalTime,
    goalDate: result.goalDate,
    recentType: result.recentTime === null ? '' : data.recentType,
    selectedAction: ['usual-run', 'record-time', 'review-goal'].includes(selectedAction) ? selectedAction : '',
  };
}

function parsePass(text, now = new Date()) {
  if (typeof text !== 'string' || text.length > 10000) throw new Error('Dit bestand is te groot of ongeldig.');
  let pass;
  try { pass = JSON.parse(text); } catch { throw new Error('Dit is geen geldige RUNNUR-resultaatpas.'); }
  const keys = ['version', 'createdAt', 'expiresAt', 'recentDistance', 'recentTime', 'goalDistance', 'goalTime', 'goalDate', 'recentType', 'selectedAction'];
  if (!pass || Array.isArray(pass) || Object.keys(pass).some(key => !keys.includes(key)) || keys.some(key => !(key in pass))) throw new Error('Deze resultaatpas bevat onbekende of ontbrekende velden.');
  if (pass.version !== GROWTH_VERSION || !dateOnly(pass.goalDate)) throw new Error('Deze resultaatpas wordt niet ondersteund.');
  for (const key of ['createdAt', 'expiresAt']) if (Number.isNaN(Date.parse(pass[key]))) throw new Error('Deze resultaatpas bevat een ongeldige datum.');
  if (new Date(pass.expiresAt) <= now) throw new Error('Deze resultaatpas is verlopen.');
  if (!(pass.goalDistance > 0 && pass.goalDistance <= 100) || (pass.recentDistance !== null && !(pass.recentDistance > 0 && pass.recentDistance <= 100))) throw new Error('Deze resultaatpas bevat een ongeldige afstand.');
  if (pass.goalTime !== null && !(pass.goalTime > 0 && pass.goalTime < 360000)) throw new Error('Deze resultaatpas bevat een ongeldige tijd.');
  if (pass.recentTime !== null && !(pass.recentTime > 0 && pass.recentTime < 360000)) throw new Error('Deze resultaatpas bevat een ongeldige tijd.');
  if (!['', 'training', 'race'].includes(pass.recentType) || !['', 'usual-run', 'record-time', 'review-goal'].includes(pass.selectedAction)) throw new Error('Deze resultaatpas bevat een ongeldige keuze.');
  return pass;
}

function comparePass(pass, result) {
  const goalDistanceDifference = result.goalDistance - pass.goalDistance;
  const goalTimeDifference = result.goalTime === null || pass.goalTime === null ? null : result.goalTime - pass.goalTime;
  return { goalDistanceDifference, goalTimeDifference, previousDate: pass.createdAt.slice(0, 10), currentDate: new Date().toISOString().slice(0, 10) };
}

function shareText(result, actionTitle = '') {
  const distance = new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 3 }).format(result.goalDistance);
  return [`Mijn RUNNUR-richting: ${distance} km.`, actionTitle ? `Mijn eerste stap: ${actionTitle}.` : '', 'Maak je eigen richting op runnur.nl/pages/doelplanner'].filter(Boolean).join('\n');
}





const root = document.querySelector('#doelplanner');
if (!root) throw new Error('Doelplanner-root ontbreekt.');
const $ = selector => root.querySelector(selector);
const $$ = selector => [...root.querySelectorAll(selector)];
const form = $('#planner-form');
const track = createAnalytics();
const escape = value => String(value).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
const km = value => new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 3 }).format(value);
let step = 1;
let result = null;
let submittedData = null;
let selectedAction = '';

function read() {
  const data = Object.fromEntries(new FormData(form));
  data.noRecent = form.elements.noRecent.checked;
  data.noGoalTime = form.elements.noGoalTime.checked;
  if (data.dateMode === 'month') data.goalDate = monthEnd(data.goalMonth) || '';
  data.obstacle = $('#obstacle')?.value || '';
  data.phase = $('#phase')?.value || '';
  data.help = $('#help')?.value || 'none';
  data.reflection = $('#reflection')?.value || '';
  return data;
}

function sync() {
  $('#recent-fields').hidden = form.elements.noRecent.checked;
  $('#goal-time').hidden = form.elements.noGoalTime.checked;
  $('#custom-distance').hidden = $('#distance-choice').value !== 'custom';
  const monthMode = form.elements.dateMode.value === 'month';
  $('#exact-date').hidden = monthMode;
  $('#month-date').hidden = !monthMode;
}

function showErrors(fields = {}) {
  $$('[data-error]').forEach(element => { element.textContent = ''; });
  $$('[aria-invalid]').forEach(element => element.removeAttribute('aria-invalid'));
  for (const [field, message] of Object.entries(fields)) {
    const key = field.replace('Hours', 'Time');
    const output = $(`[data-error="${key}"]`);
    let input = form.elements[field];
    if (field === 'goalDistance' && $('#custom-distance').hidden) input = $('#distance-choice');
    if (field === 'goalDate' && form.elements.dateMode.value === 'month') input = $('#goalMonth');
    if (output) { output.textContent = message; output.id = `err-${field}`; }
    if (input) { input.setAttribute('aria-invalid', 'true'); if (output) input.setAttribute('aria-describedby', output.id); }
  }
  const first = Object.keys(fields)[0];
  if (first) {
    let input = form.elements[first];
    if (first === 'goalDistance' && $('#custom-distance').hidden) input = $('#distance-choice');
    if (first === 'goalDate' && form.elements.dateMode.value === 'month') input = $('#goalMonth');
    input?.focus();
  }
}

function showStep() {
  $('#intro').hidden = true; $('#results').hidden = true; $('#flow').hidden = false;
  $$('[data-step]').forEach(element => { element.hidden = Number(element.dataset.step) !== step; });
  $('#step-label').textContent = `Stap ${step} van 4`; $('#progress').value = step;
  $('#next').textContent = step === 4 ? COPY.result : COPY.next;
  $(`[data-step="${step}"] h2`).focus(); sync();
}

function download(name, contents, type) {
  const url = URL.createObjectURL(new Blob([contents], { type }));
  const link = document.createElement('a'); link.href = url; link.download = name; link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

function list(items) { return `<ul>${items.map(item => `<li>${escape(item)}</li>`).join('')}</ul>`; }

function renderActions() {
  const data = { ...submittedData, obstacle: $('#obstacle').value };
  const choices = firstActions(data, result);
  $('#action-choices').innerHTML = choices.actions.map(action => `<label><input type="radio" name="firstAction" value="${action.id}"${selectedAction === action.id ? ' checked' : ''}><span><strong>${escape(action.title)}</strong><br><small>${escape(action.text)}</small>${action.id === choices.preferred ? '<br><em>Past waarschijnlijk bij je keuze</em>' : ''}</span></label>`).join('');
  $$('[name="firstAction"]').forEach(input => input.addEventListener('change', () => {
    selectedAction = input.value;
    const action = choices.actions.find(item => item.id === selectedAction);
    $('#action-status').textContent = `Gekozen: ${action.title}. Dit betekent nog niet dat je de loop hebt gedaan.`;
    $('#share-preview').textContent = shareText(result, action.title);
  }));
}

function renderContent() {
  const data = { ...submittedData, phase: $('#phase').value, help: $('#help').value };
  const cards = contentCards(data);
  $('#content-cards').innerHTML = cards.length ? cards.map(card => `<a href="${escape(card.url)}"><h3>${escape(card.title)}</h3><p>${escape(card.text)}</p><strong>Bekijk ↗</strong></a>`).join('') : '<p class="rdp-note">Kies een onderwerp als je een passende volgende link wilt zien.</p>';
}

function renderResult() {
  const r = result;
  const basis = basisCard(submittedData, r);
  $('#flow').hidden = true; $('#results').hidden = false; $('#draft-content').hidden = true;
  const primary = r.goalTime === null ? `${km(r.goalDistance)} kilometer` : `${formatPace(r.goalPace)} <span class="rdp-small">/ km</span>`;
  $('#result-content').innerHTML = `<p class="rdp-kicker">Van wens naar een eerste stap</p><h1 tabindex="-1">Dit is jouw richting</h1>
    <section class="rdp-result-main"><h2>${r.goalTime === null ? 'Jouw afstandsdoel' : 'Jouw doeltempo'}</h2><p class="rdp-big">${primary}</p><p>${r.goalTime === null ? `Je wilt ${km(r.goalDistance)} kilometer uitlopen. Een eindtijd is niet nodig om te beginnen.` : `Ongeveer ${formatPace(r.goalPace)} per kilometer om ${km(r.goalDistance)} kilometer in ${formatTime(r.goalTime)} te lopen.`}</p></section>
    <div class="rdp-grid" style="margin-top:18px"><div class="rdp-stat">Jouw vertrekpunt<strong>${r.currentPace === null ? 'Nog niet bekend' : `${formatPace(r.currentPace)} / km`}</strong>${r.currentPace === null ? 'Een recente tijd kan later helpen.' : submittedData.recentType === 'race' ? 'Gebaseerd op een wedstrijd.' : 'Gebaseerd op een training.'}</div><div class="rdp-stat">Tot jouw doel<strong>${r.weeks} volledige weken</strong>${r.daysRemaining} dagen tot ${escape(r.goalDate)}${submittedData.dateMode === 'month' ? ' · laatste dag van gekozen maand' : ''}</div></div>
    <div class="rdp-layers"><div class="rdp-layer"><b>Nu</b>${r.goalTime === null ? `Je afstand is ${km(r.goalDistance)} km.` : `Je rekent met ${formatPace(r.goalPace)} per km.`}</div><div class="rdp-layer"><b>Eerst</b>${escape(r.firstStep)}</div><div class="rdp-layer"><b>Later</b>Vul na je volgende meetmoment opnieuw in en vergelijk alleen met jezelf.</div></div>
    <section class="rdp-card"><h2>Wat deze uitslag betekent</h2><h3>${escape(r.band)}</h3><p>${escape(r.explanation)}</p><p class="rdp-note"><strong>Wat maakt dit later beter?</strong><br>${escape(improvementPrompt(submittedData, r))}</p></section>
    <section class="rdp-card"><h2>Dit gebruiken we</h2><div class="rdp-assumptions"><div><strong>Bekend</strong>${list(basis.known)}</div><div><strong>Onbekend</strong>${basis.unknown.length ? list(basis.unknown) : '<p>Niets in de kernvelden.</p>'}</div><div><strong>Aanname</strong>${list(basis.assumptions)}</div></div></section>
    <section class="rdp-card"><h2>Vergelijk zelf een tweede scenario</h2><p>Vul een andere zelfgekozen eindtijd in. Dit vergelijkt twee wensen en zegt niets over je kans op succes.</p><div class="rdp-time"><label>Uren<input id="scenario-hours" type="number" min="0" value="${r.goalTime === null ? 0 : Math.floor(r.goalTime / 3600)}"></label><label>Minuten<input id="scenario-minutes" type="number" min="0" max="59" value="${r.goalTime === null ? '' : Math.floor((r.goalTime % 3600) / 60)}"></label><label>Seconden<input id="scenario-seconds" type="number" min="0" max="59" value="${r.goalTime === null ? '' : Math.round(r.goalTime % 60)}"></label></div><button id="scenario-calc" type="button">Vergelijk scenario</button><p id="scenario-output" class="rdp-note" role="status">Nog geen tweede scenario berekend.</p></section>
    <details><summary>Bekijk de berekening en grenzen</summary><p>${r.samePaceFinish === null ? 'Zonder recente tijd is er geen tempovergelijking.' : `Bij hetzelfde tempo zou ${km(r.goalDistance)} kilometer ${formatTime(r.samePaceFinish)} duren. Dit is een rekenvoorbeeld, geen voorspelling.`}</p><p>Tempo = tijd ÷ afstand. Volledige weken = dagen ÷ 7, naar beneden afgerond. De inschatting gebruikt voorzichtige vuistregels die niet wetenschappelijk zijn gevalideerd. Deze tool geeft geen trainingsschema.</p></details><p class="rdp-small">${escape(r.disclaimer)}</p>`;
  $('#scenario-calc').addEventListener('click', () => {
    const h = Number($('#scenario-hours').value || 0), m = Number($('#scenario-minutes').value || 0), s = Number($('#scenario-seconds').value || 0);
    if (![h, m, s].every(Number.isInteger) || h < 0 || m < 0 || m > 59 || s < 0 || s > 59 || h + m + s === 0) { $('#scenario-output').textContent = 'Vul een geldige tweede eindtijd in.'; return; }
    const seconds = h * 3600 + m * 60 + s; const pace = seconds / r.goalDistance;
    $('#scenario-output').textContent = `Scenario B is ${formatTime(seconds)}: ${formatPace(pace)} per kilometer. ${r.goalTime === null ? 'Je had nog geen eerste eindtijd gekozen.' : `Dat is ${Math.abs(seconds - r.goalTime)} seconden ${seconds < r.goalTime ? 'sneller' : 'rustiger'} dan scenario A.`}`;
  });
  selectedAction = ''; renderActions(); $('#share-preview').textContent = shareText(r); renderContent();
  $('#result-content h1').focus(); track('doelplanner_result_view');
}

$('#start').addEventListener('click', () => { track('doelplanner_start'); showStep(); });
$('#back').addEventListener('click', () => { showErrors(); if (step === 1) { $('#flow').hidden = true; $('#intro').hidden = false; $('#start').focus(); } else { step -= 1; showStep(); } });
form.addEventListener('change', sync);
$('#distance-choice').addEventListener('change', () => { if ($('#distance-choice').value !== 'custom') form.elements.goalDistance.value = $('#distance-choice').value; sync(); });
form.addEventListener('submit', event => {
  event.preventDefault(); const data = read();
  const growthIssues = validateGrowth(data); const coreStep = step - 1;
  const issues = coreStep >= 1 ? validateStep(coreStep, data) : growthIssues;
  showErrors(issues); if (Object.keys(issues).length) return;
  if (step < 4) { track('doelplanner_step_complete', { step }); step += 1; showStep(); return; }
  try { submittedData = data; result = calculate(data); renderResult(); } catch (error) { showErrors(error.fields || {}); $('#form-status').textContent = 'Controleer je antwoorden. Ze blijven staan.'; }
});

$('#edit').addEventListener('click', () => { step = 1; showStep(); });
$('#restart').addEventListener('click', () => { form.reset(); selectedAction = ''; step = 1; $('#results').hidden = true; $('#intro').hidden = false; sync(); $('#start').focus(); });
$('#obstacle').addEventListener('change', renderActions);
$('#phase').addEventListener('change', renderContent); $('#help').addEventListener('change', renderContent);

$('#action-date').addEventListener('change', () => { $('#calendar-preview').textContent = $('#action-time').value ? `${$('#action-date').value} om ${$('#action-time').value}. Alleen na je klik wordt een bestand gemaakt.` : 'Kies ook een tijd.'; });
$('#action-time').addEventListener('change', () => { $('#calendar-preview').textContent = $('#action-date').value ? `${$('#action-date').value} om ${$('#action-time').value}. Alleen na je klik wordt een bestand gemaakt.` : 'Kies ook een dag.'; });
$('#calendar-download').addEventListener('click', () => { try { const title = selectedAction ? firstActions(read(), result).actions.find(action => action.id === selectedAction)?.title : 'Mijn RUNNUR-moment'; download('runnur-moment.ics', buildIcs({ title, date: $('#action-date').value, time: $('#action-time').value, description: 'Zelfgekozen moment uit de RUNNUR Doelplanner.' }), 'text/calendar;charset=utf-8'); $('#calendar-preview').textContent = 'Agenda-bestand gedownload. Jij kiest zelf of je het opent en toevoegt.'; } catch (error) { $('#calendar-preview').textContent = error.message; } });
$('#pass-download').addEventListener('click', () => download('runnur-resultaatpas.json', JSON.stringify(createPass(submittedData, result, selectedAction), null, 2), 'application/json'));
$('#pass-import').addEventListener('change', async event => { const file = event.target.files[0]; if (!file) return; try { const pass = parsePass(await file.text()); const comparison = comparePass(pass, result); $('#pass-status').textContent = `Vorige pas van ${comparison.previousDate}: doelafstand ${km(pass.goalDistance)} km. Verschil met nu: ${km(comparison.goalDistanceDifference)} km${comparison.goalTimeDifference === null ? '' : ` en ${Math.abs(comparison.goalTimeDifference)} seconden in je zelfgekozen eindtijd`}. Dit bewijst geen trainingsverbetering.`; } catch (error) { $('#pass-status').textContent = error.message; } event.target.value = ''; });
$('#share').addEventListener('click', async () => { const text = $('#share-preview').textContent; try { if (navigator.share) await navigator.share({ title: 'Mijn RUNNUR-richting', text }); else { await navigator.clipboard.writeText(text); $('#share').textContent = 'Gekopieerd'; } } catch { $('#share').textContent = 'Delen geannuleerd'; } });
$('#reflection').addEventListener('change', () => { const copy = { worked: 'Mooi: benoem voor jezelf één ding dat werkte. Een klik bewijst nog geen training.', adjust: 'Kies één klein onderdeel dat je volgende week anders wilt plannen.', missed: 'Een gemiste week wist je doel niet. Kies opnieuw, stel uit of stop zonder schuld.' }; $('#reflection-copy').hidden = !copy[$('#reflection').value]; $('#reflection-copy').textContent = copy[$('#reflection').value] || ''; });
$('#checkin-download').addEventListener('click', () => { try { download('runnur-check-in.ics', buildIcs({ title: 'Mijn RUNNUR check-in', date: $('#checkin-date').value, time: '09:00', description: 'Vul de doelplanner opnieuw in en vergelijk alleen met je eigen eerdere invoer.' }), 'text/calendar;charset=utf-8'); } catch (error) { $('#reflection-copy').hidden = false; $('#reflection-copy').textContent = error.message; } });
$('#draft').addEventListener('click', () => { const r = result; const action = firstActions(read(), r).actions.find(item => item.id === selectedAction); $('#draft-content').hidden = false; $('#draft-content').innerHTML = `<p class="rdp-kicker">Jouw complete plan · lokaal</p><h2>Nu, eerst en later.</h2><p><strong>Nu:</strong> ${r.goalTime === null ? `${km(r.goalDistance)} km uitlopen` : `${km(r.goalDistance)} km in ${formatTime(r.goalTime)} · ${formatPace(r.goalPace)} per km`}.</p><p><strong>Eerst:</strong> ${escape(action?.title || r.firstStep)}</p><p><strong>Later:</strong> vul na een volgend meetmoment opnieuw in. Vergelijk alleen met je eigen eerdere invoer.</p><p>${escape(r.explanation)}</p><p class="rdp-note">${escape(r.disclaimer)} Beschikbare dagen zijn ruimte in je agenda, geen advies om al die dagen te lopen.</p>`; $('#draft-content').focus(); });
$('#primary-cta').addEventListener('click', () => track('doelplanner_primary_cta_click'));

$('#intro h1').textContent = COPY.title; $('#start').textContent = COPY.start; $('#primary-cta').textContent = COPY.cta; $('#primary-cta').href = COPY.ctaUrl;
track('doelplanner_view'); sync();

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["runnur60-testers"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;root.querySelectorAll('[data-r60-anchor]').forEach(a=>a.addEventListener('click',e=>{const target=root.querySelector('[data-r60-signup]');if(!target)return;e.preventDefault();target.scrollIntoView({behavior:reduced?'instant':'smooth',block:'start'});target.focus({preventScroll:true})}));root.querySelectorAll('[data-r60-demo]').forEach(button=>button.addEventListener('click',()=>{const area=button.closest('.r60-form');const valid=[...area.querySelectorAll('input')].every(i=>i.reportValidity());if(valid)area.querySelector('[role="status"]').textContent='De aanmelding is nog niet geopend. Er zijn geen gegevens verstuurd.'}));root.querySelector('[data-r60-motion]')?.addEventListener('click',e=>{const paused=root.classList.toggle('r60-motion-paused');e.currentTarget.setAttribute('aria-pressed',String(paused));e.currentTarget.setAttribute('aria-label',paused?'Hervat bewegende tekst':'Pauzeer bewegende tekst');e.currentTarget.textContent=paused?'Afspelen':'Pauze'});if(reduced)return;root.classList.add('r60-motion-ready');root.classList.add('r60-enhanced');const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target)}}),{threshold:.12});root.querySelectorAll('.r60-reveal').forEach(el=>io.observe(el));const phases=[...root.querySelectorAll('[data-r60-phase]')];const steps=[...root.querySelectorAll('.r60-step')];let busy=false;const update=()=>{busy=false;const hero=root.querySelector('.r60-hero-media');if(hero){const r=hero.getBoundingClientRect();if(r.bottom>0&&r.top<innerHeight){const ratio=Math.max(-1,Math.min(1,r.top/innerHeight));hero.querySelector('img')?.style.setProperty('transform',`scale(${1.025+Math.abs(ratio)*.035}) translateY(${ratio*7}px)`)}}phases.forEach((el,i)=>steps[i]?.classList.toggle('is-active',el.getBoundingClientRect().top<innerHeight*.75))};window.addEventListener('scroll',()=>{if(!busy){busy=true;requestAnimationFrame(update)}},{passive:true});update()}document.querySelectorAll('.r60').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.r60').forEach(init))})();

  } catch(e) { console.error(e); }
})();
})();
